import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Profile from "../views/Profile.vue";
import Signup from "../views/Signup.vue";
import Signin from "../views/Signin.vue";
import TransactionsList from "../views/TransactionsList.vue";
import Categories from "../views/Categories.vue";
import AccountsList from "../views/AccountsList.vue";
import CreditCardList from '../views/CreditCardList.vue';
import InvoiceList from "../views/InvoiceList.vue";
import CardDetails from "../views/CardDetails.vue";
import Privacity from "../views/Privacity.vue";
import Support from "../views/Support.vue";
import Objetives from "../views/Objetives.vue";
import Integrations from "../views/Integrations.vue";
import Whmcs from "../views/Whmcs.vue";
import CustomersList from "../views/CustomersList.vue";

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/login",
  },
  {
    path: "/politica-de-privacidade",
    name: "Politica de Privacidade",
    component: Privacity
  },
  {
    path: "/inicio",
    name: "Visão Geral",
    component: Dashboard,
  },
  {
    path:'/transacoes',
    name:'Transações',
    component:TransactionsList
  },
  {
    path:'/fatura/:id',
    name:'Fatura',
    component:InvoiceList
  },
  {
    path:'/cartao-de-credito/:id',
    name:'Cartão de crédito',
    component:CardDetails
  },
  {
    path:'/configuracoes/categorias',
    name:'Categorias',
    component:Categories
  },
  {
    path:'/configuracoes/contas',
    name:'Contas',
    component:AccountsList
  },
  {
    path:'/configuracoes/cartoes-de-credito',
    name:'Cartões de crédito',
    component:CreditCardList
  },
  {
    path: "/minha-conta",
    name: "Minha Conta",
    component: Profile,
  },
  {
    path: "/login",
    name: "Login",
    component: Signin,
  },
  {
    path: "/cadastro",
    name: "Cadastro",
    component: Signup,
  },
  {
    path: "/suporte",
    name: "Suporte",
    component: Support,
  },
  {
    path: "/objetivos",
    name: "Objetivos",
    component: Objetives,
  },
  {
    path: "/configuracoes/integracoes",
    name: "Integrações",
    component: Integrations,
  },
  {
    path: "/configuracoes/integracoes/whmcs",
    name: "WHMCS",
    component: Whmcs,
  },
  {
    path: "/clientes",
    name: "Clientes",
    component: CustomersList,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

export default router;
